export enum Permission {
  Reports = 'retailer_reports.view',
}
